import { callUIAPI, callUIAPIStream } from '../utils/apiUtils';
import { METHOD_GET, METHOD_POST, METHOD_DELETE } from '../utils/apiUtilsConstants';

const getUploadUrl = (companyId, filename, contentType) =>
  callUIAPI('media/upload-url', { companyId, filename, contentType }, METHOD_GET, true)
    .then(res => res.data);

const confirmUpload = (data) =>
  callUIAPI('media/confirm', data, METHOD_POST, true)
    .then(res => res.data);

export const uploadFile = async (file, input) => {
  const { companyId, name, type, altText, tags, uploadContext } = input;
  const { presignedUrl, s3Key } = await getUploadUrl(companyId, file.name, file.type);
  const uploadRes = await fetch(presignedUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  });
  if (!uploadRes.ok) {
    throw new Error(`S3 upload failed: ${uploadRes.status} ${uploadRes.statusText}`);
  }
  const { item } = await confirmUpload({
    s3Key,
    name: name || file.name,
    mimeType: file.type,
    fileSize: file.size,
    type: type || 'image',
    altText,
    tags,
    companyId,
    uploadContext,
  });
  return item ?? null;
};

export const search = (companyId, filters = {}) =>
  callUIAPI('media/search', { companyId, ...filters }, METHOD_POST, true)
    .then(res => res.data);

export const searchFirm = (filters = {}) =>
  callUIAPI('media/search-firm', filters, METHOD_POST, true)
    .then(res => res.data);

export const getById = (mediaId) =>
  callUIAPI(`media/${mediaId}`, null, METHOD_GET, true)
    .then(res => res.data);

export const updateAltText = (mediaId, altText) =>
  callUIAPI(`media/${mediaId}/alt-text`, { altText }, METHOD_POST, true)
    .then(res => res.data);

export const deleteMedia = (mediaId) =>
  callUIAPI(`media/${mediaId}`, null, METHOD_DELETE, true)
    .then(res => res.data);

export const retryMedia = (mediaId) =>
  callUIAPI(`media/${mediaId}/retry`, null, METHOD_POST, true)
    .then(res => res.data);

export const importFromUrlStream = (companyId, url, limit = 50, signal) =>
  callUIAPIStream('media/import-from-url-stream', { companyId, url, limit }, METHOD_POST, signal);

export const confirmMediaPlace = (mediaId, place) =>
  callUIAPI(`media/${mediaId}/place/confirm`, place, METHOD_POST, true)
    .then(res => res.data);

export const declineMediaPlace = (mediaId, place) =>
  callUIAPI(`media/${mediaId}/place/decline`, place, METHOD_POST, true)
    .then(res => res.data);
